import moment from "moment";

import { Component, Input, Output, EventEmitter } from "@angular/core";
import { SearchResult } from "../services/consultation.service";
import { ConsultationOccasion } from "../data/model";
import { ConsultationService } from "../services/consultation.service";
import { ZASConstants } from "../data/model.constants";

@Component({
    selector: "zbd-search-results",
    templateUrl: "search-results.component.html",
    styles: [
        `
            .clickable {
                cursor: pointer;
            }
        `,
    ],
})
export class SearchResultsComponent {
    @Input() consultationProcessSearchResults: SearchResult[];
    @Input() moreResults: boolean;
    @Input() searching: boolean;
    @Output() onSearchMore: EventEmitter<void> = new EventEmitter<void>();

    ZASConstants = ZASConstants;
    moment = moment;

    constructor(private consultationService: ConsultationService) {}

    searchMore(): void {
        //this.moreResults = false
        this.onSearchMore.emit();
    }

    downloadDocument(documentId: number): void {
        this.consultationService.getDocument(documentId).subscribe((doc) => {
            this.consultationService.downloadDocument(doc);
        });
    }
}
